if (typeof DynaCore_Field_Filter == "undefined") {
    var DynaCore_Field_Filter =
    {
        init: function()
        {
            // Pridani
            $("#filters").off('click', '.filter-add');
            $("#filters").on('click', '.filter-add', function () {
                DynaCore_Field_Filter.add(this);

                return false;
            });

            // Smazani
            $("#filters").off('click', '.filter-delete');
            $("#filters").on('click', '.filter-delete', function () {
                DynaCore_Field_Filter.delete(this);

                return false;
            });

            // Upraveni
            $("#filters").off('click', '.filter-edit');
            $("#filters").on('click', '.filter-edit', function () {
                DynaCore_Field_Filter.edit(this);

                return false;
            });
        },

        /**
         * Pridano bloku podminky
         *
         * @param element
         */
        add: function (element)
        {
            var filterIndex = $('#filters').find('tbody > tr').length;
            var relationTarget = $('#relationTarget').val();
            var relationList = $('#relationList').val();
            var relationMiniform = $('#relationMiniform').val();
            var relationSection = $('#relationSection').val();
            var relationPattern = $('#relationPattern').val();

            var url = window.location.href.replace(/\/field\/(.*)/, '/field/filter');
            url += '?_ch=' + $('#_ch').val();
            url += '&act=add';
            url += '&filInd=' + filterIndex;
            url += '&relTar=' + relationTarget;
            url += '&relLis=' + relationList;
            url += '&relMin=' + relationMiniform;
            url += '&relSec=' + relationSection;
            url += '&relPat=' + relationPattern;

            $('.relationField').each(function(i, el) {
                url += '&relFie[]=' + $(el).val();
            });

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                beforeSend: function () {
                    $(element).attr('disabled', true).prop('disabled', true);
                },
                complete: function () {
                    $(element).attr('disabled', false).prop('disabled', false);
                },
                success: function (response) {
                    Lemo_Modal.setTitle('Filter');
                    Lemo_Modal.setContent(response.html);
                    Lemo_Modal.setSize('large');
                    Lemo_Modal.addButton('add', '<i class="fas fa-fw fa-check"></i> ' + translate('Add'), 'btn btn-primary', function() {
                        $.ajax({
                            type: 'post',
                            url: url,
                            data: $('#modal :input').serialize(),
                            dataType: "json",
                            success: function(response) {
                                $.each(response.messages, function(i, message) {
                                    Lemo_Alert.build(message.type, message.title, message.text);
                                });

                                if (true === response.status) {
                                    $('#filters').find('tbody').append(response.html);
                                    Lemo_Modal.close();
                                } else {
                                    $('#dialogBody').html(response.html);
                                }

                            },
                            error: function(html) {
                                Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly');

                                $('#dialogBody').html(html.responseText);
                            }
                        });
                    });
                    Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function() {
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.build();

                    DynaCore_Field_Filter.editInit();
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        edit: function(element)
        {
            var filterIndex = $(element).parents('tr').data('filter-index');
            var relationTarget = $('#relationTarget').val();
            var relationList = $('#relationList').val();
            var relationMiniform = $('#relationMiniform').val();
            var relationSection = $('#relationSection').val();
            var relationPattern = $('#relationPattern').val();

            var url = window.location.href.replace(/\/field\/(.*)/, '/field/filter');
            url += '?_ch=' + $('#_ch').val();
            url += '&act=edit';
            url += '&filInd=' + filterIndex;
            url += '&relTar=' + relationTarget;
            url += '&relLis=' + relationList;
            url += '&relMin=' + relationMiniform;
            url += '&relSec=' + relationSection;
            url += '&relPat=' + relationPattern;

            $('.relationField').each(function(i, el) {
                url += '&relFie[]=' + $(el).val();
            });

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                beforeSend: function () {
                    $(element).attr('disabled', true).prop('disabled', true);
                },
                complete: function () {
                    $(element).attr('disabled', false).prop('disabled', false);
                },
                success: function (response) {
                    Lemo_Modal.setTitle('Filter');
                    Lemo_Modal.setContent(response.html);
                    Lemo_Modal.setSize('large');
                    Lemo_Modal.addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function() {
                        $.ajax({
                            type: 'post',
                            url: url,
                            data: $('#modal :input').serialize(),
                            dataType: "json",
                            success: function(response) {
                                $.each(response.messages, function(i, message) {
                                    Lemo_Alert.build(message.type, message.title, message.text);
                                });

                                if (true === response.status) {
                                    $('#filters').find('tr[data-filter-index="' + filterIndex + '"]').replaceWith(response.html);
                                    Lemo_Modal.close();
                                } else {
                                    $('#dialogBody').html(response.html);
                                }
                            },
                            error: function() {
                                Lemo_Alert.addDanger('An unexpected error occurred');
                            }
                        });
                    });
                    Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function() {
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.build();

                    DynaCore_Field_Filter.editInit();
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        editInit: function ()
        {
            DynaCore_Combination.init();

            // Upraveni
            $("#filter").off('change', '.filter-valuesType');
            $("#filter").on('change', '.filter-valuesType', function () {

                // Automaticky vybrane hodnoty z urciteho pole
                if ('automaticallyFromField' == this.value) {
                    $("#filter").find('.filter-valuesField').parents('.form-group').removeClass('d-none');
                } else {
                    $("#filter").find('.filter-valuesField:first').val('');
                    $("#filter").find('.filter-valuesField').not(':first').parents('.form-group').remove();
                    $("#filter").find('.filter-valuesField').parents('.form-group').addClass('d-none');
                }

                // Rucne vybrane hodnoty
                if ('manually' == this.value) {
                    $("#filter").find('#form-group-valuesId').removeClass('d-none');
                } else {
                    $("#filter").find('#form-group-valuesId').addClass('d-none');
                    $("#filter").find('#form-group-valuesId').find("option:selected").removeAttr('selected');
                }

                return false;
            });

            // Nacteni dalsiho pole relace
            $("#filter").off('change', '.filter-valuesField');
            $("#filter").on('change', '.filter-valuesField', function () {
                DynaCore_Field_Filter.valuesFieldLoad(this);

                return false;
            });
        },

        /**
         * Smazani filtru
         */
        delete: function (element)
        {
            var filterIndex = $(element).parents('tr').data('filter-index');

            var url = window.location.href.replace(/\/field\/(.*)/, '/field/filter-delete');
            url += '?_ch=' + $('#_ch').val();
            url += '&filInd=' + filterIndex;

            Lemo_Modal.setTitle('Remove filter');
            Lemo_Modal.setContent('<p class="text">' + translate('Do you really want to remove selected filter?') + '</p>');
            Lemo_Modal.addButton('remove', '<i class="fas fa-fw fa-trash"></i> ' + translate('Remove'), 'btn btn-danger', function () {
                $.ajax({
                    type: 'get',
                    url: url,
                    dataType: "json",
                    beforeSend: function () {
                        $(element).attr('disabled', true).prop('disabled', true);
                    },
                    complete: function () {
                        $(element).attr('disabled', false).prop('disabled', false);

                        Lemo_Modal.close();
                    },
                    success: function (response) {
                        $.each(response.messages, function(i, message) {
                            Lemo_Alert.build(message.type, message.title, message.text);
                        });

                        if (true === response.status) {
                            $(element).parents('tr').remove();

                            DynaCore_Field_Filter.reindex();
                        }
                    },
                    error: function() {
                        Lemo_Alert.addDanger('An unexpected error occurred');
                    }
                });
            });
            Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function () {
                Lemo_Modal.close();
            });
            Lemo_Modal.build();
        },

        /**
         * Preindexuje filtry
         */
        reindex: function ()
        {
            $('#filters').find('tbody > tr').each(function (i, trElement) {
                $(trElement).attr('data-filter-index', i);
            });
        },

        /**
         * Nacte detail pole
         *
         * @param element
         */
        valuesFieldLoad: function (element)
        {
            var fieldIndex = $(element).attr('name').match(/(\d+)/g);

            var url = window.location.href.replace(/\/field\/(.*)/, '/field/load-fields-from-relation-target');
            url += '?_ch=' + $('#_ch').val();
            url += '&fieId=' + element.value;

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                success: function (response) {
                    $.each(response.messages, function(i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text);
                    });

                    if (true === response.status) {
                        DynaCore_Field_Filter.valuesFieldRemove(fieldIndex);

                        if (response.data.fields.length > 1) {
                            DynaCore_Field_Filter.valuesFieldCreate(response.data.fields);
                        }
                    }
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        /**
         * Vytvori pole a prida ho do formulare
         *
         * @param fields
         */
        valuesFieldCreate: function (fields)
        {
            var span = $('#form-template-valuesFields');
            var template = $(span).attr('data-template');
            var count = $('.filter-valuesField').length;

            template = template.replace(/__index__/g, count);

            // Parse HTML
            template = $.parseHTML(template);

            // Remove existing options
            $(template).find('option').remove();

            // Append new options
            $.each(fields, function (i, item) {
                $(template).find('select').append($('<option value="' + item.i + '">' + item.l + '</option>'));
            });

            template = $(template)[0].outerHTML;

            $(span).before(template);
        },

        /**
         * Odebre pole z formulare
         *
         * @param fieldIndex
         */
        valuesFieldRemove: function (fieldIndex) {
            $('.filter-valuesField').each(function(i, element) {
                if (i > fieldIndex) {
                    $(element).parents('.form-group').remove();
                }
            });
        }
    }
}
